// extracted by mini-css-extract-plugin
export default {"title":"BPieChart-module_title_bc752cdf"};